import $ from "jquery";

export default function () {
  const $megamenuContents = $("[data-parent-link]");
  $megamenuContents.each(function (index, megamenuContent) {
    const parentLink = $(megamenuContent).data("parent-link");
    if (parentLink != "") {
      if ($(window).width() < 990) {
        $(megamenuContent).attr("data-accordion-content", "");
      }
      $("[data-megamenu=" + parentLink + "]")
        .addClass("has-megamenu")
        .append($(megamenuContent).parent().html());
      // $('[data-megamenu=' + parentLink + '] a.m-level-1').addClass('has-plus-icon');

      if ($(window).width() < 990) {
        $("[data-megamenu=" + parentLink + "]")
          .find("a.nav__link")
          .attr("data-accordion-button", "");
      }
    }
  });

  let hoverTimer;
  $("[data-megamenu].has-megamenu").on("mouseenter", function () {
    clearTimeout(hoverTimer);
    $("body").addClass("megamenu-open");
    $(".menu-overlay").addClass("visible");
  });

  $("[data-megamenu].has-megamenu").on("mouseleave", function () {
    hoverTimer = setTimeout(function () {
      $(".menu-overlay").removeClass("visible");
      $("body").removeClass("megamenu-open");
    }, 0); // Adjust the delay time as needed
  });
}
